import { useMemo } from 'react';

import { SupportedCurrency } from '@sorare/core/src/__generated__/globalTypes';
import {
  MonetaryAmountOutput,
  Sum,
  useMonetaryAmount,
} from '@sorare/core/src/hooks/useMonetaryAmount';
import { useFiatBalance } from '@sorare/core/src/hooks/wallets/useFiatBalance';
import { getMonetaryAmountIndex } from '@sorare/core/src/lib/monetaryAmount';

export const useCalculateWalletAndCreditCardSplit = (
  monetaryAmount: MonetaryAmountOutput
) => {
  const { availableBalanceInCents, fiatCurrency } = useFiatBalance();
  const bigAvailableFiatCentsBalance = BigInt(-1 * availableBalanceInCents);
  const { toMonetaryAmount } = useMonetaryAmount();

  const fiatWalletMonetaryAmount = useMemo(() => {
    return toMonetaryAmount({
      [getMonetaryAmountIndex(fiatCurrency)]: bigAvailableFiatCentsBalance,
      referenceCurrency: getMonetaryAmountIndex(
        fiatCurrency
      ) as SupportedCurrency,
    });
  }, [bigAvailableFiatCentsBalance, fiatCurrency, toMonetaryAmount]);
  const creditCardMonetaryAmount = useMemo(() => {
    return Sum([monetaryAmount, fiatWalletMonetaryAmount]);
  }, [monetaryAmount, fiatWalletMonetaryAmount]);
  return { creditCardMonetaryAmount, fiatWalletMonetaryAmount };
};
